import { computed } from '@vue/composition-api'
import { updateQuery, getQueryParam } from '@/utils/router'
import moment from 'moment'
import { DB_DATE } from '@/constants'
import store from '@/store'
import useSchoolSettings from '@/components/composables/useSchoolSettings'

function isEffectiveDatesRangeDefault ([ start, end ]) {
  const today = moment().format(DB_DATE)
  return (!start || start === today) && (!end || end === today)
}

export default function useEffectiveDatesRange (root) {
  const terms = store.getters.terms
  const viewingTerm = store.getters.viewingTerm
  const matchedTerm = terms.find(term => term.id === viewingTerm.id)
  const { schoolSettings } = useSchoolSettings()
  const initialStartDate = schoolSettings.value.defaultDatingMethod === 'terms' && matchedTerm
    ? matchedTerm.effectiveStartDate || matchedTerm.startDate
    : moment().format(DB_DATE)

  const effectiveDatesRange = computed(() => {
    const dateRange = getQueryParam(root.$route, 'effectiveDatesRange') || initialStartDate
    if (!dateRange) return []
    return Array.isArray(dateRange)
      ? dateRange
      : dateRange.split(',')
  })
  const effectiveDatesRangeString = computed(() => effectiveDatesRange.value.join(','))

  function updateEffectiveDatesRangeQuery (effectiveDatesRange) {
    const updateValue = isEffectiveDatesRangeDefault(effectiveDatesRange)
      ? undefined
      : effectiveDatesRange.filter(Boolean).join(',')
    return root.$router.replace(updateQuery(root.$route, {
      effectiveDatesRange: updateValue,
    }))
  }

  return {
    effectiveDatesRange,
    effectiveDatesRangeString,
    updateEffectiveDatesRangeQuery,
  }
}

export function getEffectiveDatesRange (resource = {}) {
  const { effectiveStartDate, effectiveEndDate } = resource.value || resource
  return isEffectiveDatesRangeDefault([ effectiveStartDate, effectiveEndDate ])
    ? ''
    : [ effectiveStartDate, effectiveEndDate ].filter(Boolean).join(',')
}
